module.exports = __webpack_public_path__ + "static/media/nuvemshop5.df3e99ef.png";